export default __webpack_public_path__ + "static/media/se.3dc09b9e.svg";